'use strict';
Dafi.View.MapPreloader = {
    render: function () {
        return tmpl('template-map-preloader');
    },
    appendTo: function($element) {
        var preloader = this.render();
        $($element).append(preloader);
    }
};